const sortByDateTime = (e) => {
  e.sort((a, b) =>
    a.data.rearview_agenda[0].data
      .agenda_start_time >
    b.data.rearview_agenda[0].data
      .agenda_start_time
      ? 1
      : -1
  )
  return e
}

const sortByTitle = (e) => {
  e.sort((a, b) =>
    a.data.rearview_title
    > b.data.rearview_title
    ? 1
    : -1
  )
  return e
}

const sortSort = (e) => {
  e.sort((a, b) =>
    a.data.sort
    > b.data.sort
    ? 1
    : -1
  )
  return e
}

const pushItems = (e, array) => {
  e.forEach((i) => {
    array.push(i)
  })
}


const rearviewSorting = (e) => {
  // sorting all videos first by manually set number, secondly by the release date/time
  // and if nothing of the previous is specified the default graphql sort will be applied (by title)

  let numbered = []
  let presorted = []
  let unsorted = []

  e.forEach(
    ( node ) => {
      let el = node
      Object.keys(node).includes("node") ? (el = node.node) : (el = node)
      if (el.data.publish !== true) {
        return false
      }

      if (el.data.sort != null) {
        numbered.push(el)
      } else if (
        el.data.rearview_agenda &&
        el.data.rearview_agenda !==
          undefined &&
        el.data.rearview_agenda !== null
      ) {
        if (
          el.data.rearview_agenda
            .length > 1
        ) {
          el.data.rearview_agenda.sort(
            (a, b) =>
              a.data.agenda_start_time >
              b.data.agenda_start_time
          )
        }
        presorted.push(el)
      } else if (
          el.data.rearview_release
        ) {
          el.data.rearview_agenda = []
          el.data.rearview_agenda[0] = {
            data: {
              "agenda_start_time" : el.data.rearview_release
            }
          }
          presorted.push(el)
      } else {
        unsorted.push(el)
      }
    }
  )

  sortSort(numbered)
  sortByDateTime(presorted)
  sortByTitle(unsorted)

  let tempsorted = []
  let sorted = []

  presorted.forEach((e, index) => {
    let prev = index > 0 ? presorted[index - 1] : undefined
    let current = e
    
    if (
      (prev && current.data.rearview_agenda[0].data.agenda_start_time
      !== prev.data.rearview_agenda[0].data.agenda_start_time)
    ) {
        
      sortByTitle(tempsorted)
      pushItems(tempsorted, sorted)
      
      tempsorted = []
      tempsorted.push(current)
      
      if ( index + 1 === presorted.length ) {
        pushItems(tempsorted, sorted)
      }
    } else if ( index + 1 === presorted.length ) {
      tempsorted.push(current)
      sortByTitle(tempsorted)
      pushItems(tempsorted, sorted)
    } else {
      tempsorted.push(current)
    }
  })

  //console.log(presorted)
  //console.log(sorted)


  // not necessary as the default graphql sort already takes care of that
  // unsorted.sort((a, b) => (a.data.rearview_title > b.data.rearview_title) ? 1 : -1)

  let combined = numbered
    .concat(sorted)
    .concat(unsorted)
  
  return combined
};

module.exports = rearviewSorting